import type { WebapiEndpointBuilder } from '@/api/webapi.ts';

export const cancelFixing = (builder: WebapiEndpointBuilder) => {
  return builder.mutation<void, string>({
    query: (request) => ({
      url: '/oms/cancel/Fixing',
      method: 'POST',
      body: { orderRef: request },
      headers: {
        // without this header, the response is a string
        // instead of JSON, even if the value is "application/json"
        //accept: '*/*',
      },
    }),
  });
};
